module.exports = __webpack_public_path__ + "images/project/type-select-kanban-ca491cd2c33913467f38425d479d3ac9.png";